import { BounceSetupModule } from '../../../../components/displays/alerts/components/addAlertComponent/addAlertForm/formComponents/setup/setupDetails/setupDetailsModules/bounce/BounceSetupModule';
import { BounceDetailsComponent } from '../../../../components/displays/alerts/components/alertWatchlistComponent/setupDetailsComponents/bounce/BounceDetailsComponent';
import { parseBounceNotificationDetails } from '../../../../components/displays/alerts/components/notificationComponent/notificationListItem/notificationSetupParsers/parseBounceNotificationDetails';
import { BounceLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/BounceLine';
import { SimpleBounceLine } from '../../../../components/displays/newTradingInterface/tradingModule/components/chart/chartElements/tacticLines/SimpleBounceLine';
import { BounceTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/setups/BounceTacticPanel';
import { BounceWrapper } from '../../../../components/displays/tradeplans/softOrderModules/setupModules/bounceModule/wrapper/BounceWrapper';
import bounceDoc from '../../../../components/forms/tradeplans/documentation/BounceDocumentation';
import { bounceDetailParser } from '../../../../stores/websocketStore/utils/mungingUtils/alertSoftOrderProcessing/individualSetupDetailParsers/bounce/bounceDetailParser';
import { BounceData } from './bounceData';
import { validateBounce } from './validateBounce';



export const Bounce = {
  //data class
  dataStore: BounceData,

  //string constants
  name: 'BOUNCE',
  tacticLabel: 'Bounce',
  addTacticLabel: 'Add Bounce',
  category: 'Setup',

  
  //components
  tradePlanFormModule: null,
  tacticPanel: BounceTacticPanel,
  addTacticPanel: null,
  wrapper: BounceWrapper,
  chartSoftOrderComponent: BounceLine,
  documentation: bounceDoc,
  alertDetailsComponent: BounceSetupModule, 
  alertTableSetupComponent: BounceDetailsComponent,
  simpleChartComponent: SimpleBounceLine,

  //functions
  setupDetailParser: bounceDetailParser, 
  setupNotificationParser: parseBounceNotificationDetails,
  determineTimeUnit: () => null,
  determineCandleDuration: () => null,
  validateFunction: validateBounce,
};
